<template>
  <div class="header-app">
    <v-layout align-center>
      <!--  Hamburger  -->
      <v-btn
        v-if="$vuetify.breakpoint.mdAndDown"
        icon
        @click="mobileDrawer = !mobileDrawer"
      >
        <v-icon>menu</v-icon>
      </v-btn>

      <v-flex xs3 class="d-flex justify-start">
        <div class="header-responsive">
          <v-img
            max-width="81px"
            class="flex-center-col header-logo"
            :src="require('../assets/img/cafe-amazon-logo.png')"
          ></v-img>
        </div>
      </v-flex>

      <!-- old ค้นหาข้อมูลบริษัท, หลักสูตร, แบบฟอร์ม -->
      <v-flex xs5 sm5 md3 class="pl-3 d-flex justify-start">
        <TextField
          prepend-in-icon="search"
          placeholder="ค้นหาข้อมูลข่าวสาร, หลักสูตร, บทความ"
          background-color="#F4F6F8"
          :outlined="false"
          class="search-field"
          style="max-width: 343px"
          :value="keyword"
          @onChange="keyword = $event"
          @onEnter="onSearch"
        ></TextField>
      </v-flex>

      <v-flex
        xs3
        class="d-flex justify-end pr-3"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <div class="cursor-pointer font-14" @click="branchDialog = true">
          สาขา: {{ branchINV }}{{ branchCode }} {{ branchName }}
          <v-icon>mdi-chevron-down</v-icon>
        </div>
      </v-flex>

      <v-spacer v-if="$vuetify.breakpoint.smAndDown" />

      <v-flex shrink class="d-flex justify-center">
        <v-layout align-center>
          <v-flex shrink>
            <div class="desktop-header-menus">
              <div class="flex-center-col">
                <div class="flex-center-col">
                  <!--  User  -->
                  <v-menu
                    offset-y
                    content-class="custom-menu"
                    nudge-bottom="10px"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="flex-center" v-on="on">
                        <v-img
                          :min-height="
                            $vuetify.breakpoint.mdAndUp ? '40' : '30'
                          "
                          :min-width="$vuetify.breakpoint.mdAndUp ? '40' : '30'"
                          :max-width="$vuetify.breakpoint.mdAndUp ? '40' : '30'"
                          :max-height="
                            $vuetify.breakpoint.mdAndUp ? '40' : '30'
                          "
                          class="profile-icon mr-md-2 mx-2"
                          :src="form.SmallPhotoUrl"
                        >
                          <template v-slot:placeholder>
                            <v-sheet color="#E5E5E5" height="100%"></v-sheet>
                          </template>
                        </v-img>
                        <div v-if="$vuetify.breakpoint.mdAndUp">
                          <div
                            class="txt-normal theme-color-virtualblack font-weight-bold"
                          >
                            {{ form.FirstName }} {{ form.LastName }}
                          </div>
                          <div class="txt-mini theme-color-two">
                            {{ form.Role__c }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <v-sheet color="#fff" class="menu-profile">
                      <v-layout justify-space-between align-center mb-4>
                        <v-flex shrink>ข้อมูลส่วนตัว</v-flex>
                        <!-- <v-flex shrink>
                          <v-btn icon @click="isEdit = true">
                            <v-icon color="var(--theme-color-one)">
                              mdi-pencil-outline
                            </v-icon>
                          </v-btn>
                        </v-flex> -->
                      </v-layout>

                      <!-- <v-layout
                        justify-space-between
                        align-center
                        mb-3
                        class="font-14"
                      >
                        <v-flex shrink>เบอร์โทร</v-flex>
                        <v-flex shrink style="color: #637381">{{
                          form.Phone
                        }}</v-flex>
                      </v-layout> -->

                      <v-layout
                        justify-space-between
                        align-center
                        mb-3
                        class="font-14"
                      >
                        <v-flex shrink>ชื่อ-นามสกุล</v-flex>
                        <v-flex shrink style="color: #637381"
                          >{{ form.FirstName }} {{ form.LastName }}</v-flex
                        >
                      </v-layout>

                      <v-layout
                        justify-space-between
                        align-center
                        mb-3
                        class="font-14"
                      >
                        <v-flex shrink>ตำแหน่ง</v-flex>
                        <v-flex shrink style="color: #637381">{{
                          form.Role__c
                        }}</v-flex>
                      </v-layout>

                      <v-layout
                        justify-space-between
                        align-center
                        mb-3
                        class="font-14"
                      >
                        <v-flex shrink>เบอร์โทร</v-flex>
                        <v-flex shrink style="color: #637381">{{
                          form.MobilePhone.replace(/(\d{3})(\d{6}|\d{7})/, "$1-$2")
                        }}</v-flex>
                      </v-layout>

                      <v-layout
                        justify-space-between
                        align-center
                        mb-3
                        class="font-14"
                      >
                        <v-flex shrink>อีเมล</v-flex>
                        <v-flex shrink style="color: #637381">
                          {{ form.Email }}
                        </v-flex>
                      </v-layout>

                      <!-- <v-layout
                        justify-space-between
                        align-center
                        mb-3
                        class="font-14"
                      >
                        <v-flex shrink>LINE ID</v-flex>
                        <v-flex shrink style="color: #637381">
                          {{ form.LINEID__c }}
                        </v-flex>
                      </v-layout> -->

                      <Button
                        type="9"
                        label="ออกจากระบบ"
                        width="100%"
                        @onClick="onLogout"
                      ></Button>
                    </v-sheet>
                  </v-menu>
                </div>
              </div>
            </div>
          </v-flex>

          <v-flex shrink v-if="$vuetify.breakpoint.mdAndUp">
            <Divider
              :vertical="true"
              long="40px"
              margin-level="6"
              border-color="#E5E8EB"
            ></Divider>
          </v-flex>

          <v-flex shrink>
            <v-menu
              offset-y
              content-class="custom-menu"
              nudge-bottom="10px"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  elevation="0"
                  class="notification-menu mr-4"
                  color="transparent"
                  v-on="on"
                >
                  <div v-if="!!badgeCount" class="custom-badge">
                    {{ badgeCount }}
                  </div>
                  <span class="material-symbols-outlined"> notifications </span>
                </v-btn>
              </template>
              <v-sheet class="notification-background">
                <div v-if="notificationList.length > 0" class="noti-header">
                  <div
                    class="font-18 font-w-700 d-flex justify-space-between align-center pa-4"
                  >
                    <div>แจ้งเตือน</div>
                    <div>
                      <v-btn text @click="seeAll()">
                        <span>ดูทั้งหมด</span>
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <NotiCardList
                    :items="notificationList"
                    :on-accept="onAccept"
                  />
                </div>
                <div v-else class="flex-center txt-normal theme-color-two">
                  No new update...
                </div>
              </v-sheet>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <BranchDialog
      :dialog="branchDialog"
      @close="branchDialog = false"
      @accept="onChangeBranchAccept()"
    />

    <SideMenu
      v-if="$vuetify.breakpoint.mdAndDown"
      :value="mobileDrawer"
      :right="false"
      :dataDialog="{
        branchINV: branchINV,
        branchCode: branchCode,
        branchName: branchName,
      }"
      @branchDialog="branchDialog = true"
      @onClose="mobileDrawer = false"
    ></SideMenu>

    <!-- Dialog Update User -->
    <UserDialog
      :dialog="isEdit"
      :formData="form"
      @close="isEdit = false"
      @accept="isEdit = false"
    />
  </div>
</template>

<script>
import Divider from "@/components/Divider";
import TextField from "@/components/Input/TextField";
import { eventBus, parentRoute } from "../plugins/global-funcs";
import { format } from "date-fns";
import { mapState } from "vuex";
import {
  controllerName,
  mainSite,
  logOutUrl,
  mainPage,
} from "../store/constants";
import SideMenu from "./SideMenu.vue";
import Button from "@/components/Input/Button";
import NotiCardList from "./NotiCardList.vue";
import BranchDialog from "./BranchDialog.vue";
import UserDialog from "./UserDialog.vue";

export default {
  name: "Header",
  components: {
    Divider,
    TextField,
    SideMenu,
    Button,
    NotiCardList,
    BranchDialog,
    UserDialog,
  },
  data() {
    return {
      branchDialog: false,
      isEdit: false,
      format,
      mainSite,
      defaultMenu: "Order",
      notificationList: [
        // {
        //   Acknowledged__c: false,
        //   Body__c: "เคส Complaint ถูกสร้างโดย Pongrob Saisuwan",
        //   Case__c: "5000p000009KpqqAAC",
        //   CreatedById: "0055i0000013mWTAAY",
        //   CreatedDate: 1669647907000,
        //   Header__c: "แจ้งเตือนรายการเคส Complaint",
        //   Id: "a090p000004YMtSAAW",
        //   IsDeleted: false,
        //   LastModifiedById: "0055i0000013mWTAAY",
        //   LastModifiedDate: 1669647907000,
        //   Name: "N-000068",
        //   NeedAcknowledge__c: false,
        //   OwnerId: "0055i0000013mWTAAY",
        //   Read__c: false,
        //   SystemModstamp: 1669647907000,
        //   TargetingRecord__c: "5000p000009Kpqq",
        //   NotificationType__c: "Franchise"
        // },
        // {
        //   Acknowledged__c: false,
        //   Body__c: "เคส Inquiry ถูกสร้างโดย Pongrob Saisuwan",
        //   Case__c: "5000p000009KpqRAAS",
        //   CreatedById: "0055i0000013mWTAAY",
        //   CreatedDate: 1669646096000,
        //   Header__c: "แจ้งเตือนรายการเคส Inquiry",
        //   Id: "a090p000004YMtIAAW",
        //   IsDeleted: false,
        //   LastModifiedById: "0055i0000013mWTAAY",
        //   LastModifiedDate: 1669646096000,
        //   Name: "N-000066",
        //   NeedAcknowledge__c: false,
        //   OwnerId: "0055i0000013mWTAAY",
        //   Read__c: false,
        //   SystemModstamp: 1669646096000,
        //   TargetingRecord__c: "5000p000009KpqR",
        //   NotificationType__c: "Case"
        // },
        // {
        //   Acknowledged__c: false,
        //   Body__c: "เคส Inquiry ถูกสร้างโดย Pongrob Saisuwan",
        //   Case__c: "5000p000009KoJ2AAK",
        //   CreatedById: "0055i0000013mWTAAY",
        //   CreatedDate: 1669606392000,
        //   Header__c: "แจ้งเตือนรายการเคส Inquiry",
        //   Id: "a090p000004YMSIAA4",
        //   IsDeleted: false,
        //   LastModifiedById: "0055i0000013mWTAAY",
        //   LastModifiedDate: 1669606392000,
        //   Name: "N-000060",
        //   NeedAcknowledge__c: false,
        //   OwnerId: "0055i0000013mWTAAY",
        //   Read__c: false,
        //   SystemModstamp: 1669606392000,
        //   TargetingRecord__c: "5000p000009KoJ2",
        //   NotificationType__c: "Promotion"
        // },
        // {
        //   Acknowledged__c: false,
        //   Body__c: "เคส Inquiry ถูกสร้างโดย Pongrob Saisuwan",
        //   Case__c: "5000p000009KoJ2AAK",
        //   CreatedById: "0055i0000013mWTAAY",
        //   CreatedDate: 1669606392000,
        //   Header__c: "แจ้งเตือนรายการเคส Inquiry",
        //   Id: "a090p000004YMSIAA4",
        //   IsDeleted: false,
        //   LastModifiedById: "0055i0000013mWTAAY",
        //   LastModifiedDate: 1669606392000,
        //   Name: "N-000060",
        //   NeedAcknowledge__c: false,
        //   OwnerId: "0055i0000013mWTAAY",
        //   Read__c: false,
        //   SystemModstamp: 1669606392000,
        //   TargetingRecord__c: "5000p000009KoJ2",
        //   NotificationType__c: "News"
        // },
      ],
      branchINV: "",
      branchCode: "",
      branchName: "",
      isMarkingAsRead: false,
      mobileDrawer: false,
      keyword: "",
      form: {
        FirstName: "",
        LastName: "",
        CompanyName: "",
        BranchName: "",
        Role__c: "",
        Phone: "",
        MobilePhone: "",
        Email: "",
        LINEID__c: "",
      },
    };
  },
  mounted() {
    // OneTrust Cookies Consent Notice start for pttororg1--devpro1.sandbox.my.site.com
    // let cookieScript1 = document.createElement("script");
    // cookieScript1.setAttribute("type", "text/javascript");
    // cookieScript1.setAttribute(
    //   "src",
    //   "https://cdn.cookielaw.org/consent/146c0479-8281-4f34-a536-b322de1e78ac-test/OtAutoBlock.js"
    // );
    // document.head.appendChild(cookieScript1);

    // let cookieScript = document.createElement("script");
    // cookieScript.setAttribute("type", "text/javascript");
    // cookieScript.setAttribute(
    //   "src",
    //   "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
    // );
    // cookieScript.setAttribute("data-document-language", true);
    // cookieScript.setAttribute("charset", "UTF-8");
    // cookieScript.setAttribute(
    //   "data-domain-script",
    //   "146c0479-8281-4f34-a536-b322de1e78ac-test"
    // );
    // document.head.appendChild(cookieScript);

    // let cookieScriptFn = document.createElement("script");
    // cookieScriptFn.setAttribute("type", "text/javascript");
    // cookieScriptFn[
    //   cookieScriptFn.innerText === undefined ? "textContent" : "innerText"
    // ] = "function OptanonWrapper() { }";
    // document.head.appendChild(cookieScriptFn);
    // OneTrust Cookies Consent Notice start for pttororg1--devpro1.sandbox.my.site.com

    // Create the first script element
    var script1 = document.createElement('script');
    script1.type = 'text/javascript';
    script1.src = 'https://cdn-apac.onetrust.com/consent/2271a90f-c952-4569-881a-e402ae9ae7d9/OtAutoBlock.js';

    // Create the second script element
    var script2 = document.createElement('script');
    script2.src = 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js';
    script2.setAttribute('data-document-language', 'true');
    script2.type = 'text/javascript';
    script2.charset = 'UTF-8';
    script2.setAttribute('data-domain-script', '2271a90f-c952-4569-881a-e402ae9ae7d9');

    // Create the third script element
    var script3 = document.createElement('script');
    script3.type = 'text/javascript';
    script3.innerHTML = 'function OptanonWrapper() { }';

    // Append the scripts to the head element
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(script1);
    head.appendChild(script2);
    head.appendChild(script3);

  },
  created() {
    this.getBranchInfo();
    // use getUserInfo instead
    // this.getCurrentUser();
    this.getCurrentNotifications();

    window.onresize = () => {
      if (window.innerWidth > 1263) {
        this.mobileDrawer = false;
      }
    };

    this.getUserInfo();

    // set keyword to search box
    if (this.$route.query && this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
    }

    // check open modal branch Dialog
    if (mainPage === "Dashboard" && this.$route.query.branchDialog == 1) {
      this.branchDialog = true;
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.Auth.userInfo,
    }),
    badgeCount() {
      return this.notificationList
        .map((x) => (x.Read__c ? 0 : 1))
        .reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    getBranchInfo() {
      // this.$store.commit("General/setLoading");
      this.$lc.callApex(`${controllerName}.getBranchInfoData`, (res, event) => {
        console.log(res);
        console.log(event);

        if (event.status && event.statusCode === 200) {
          this.branchCode = res.BranchCode__c;
          this.branchINV = res.INVCode__c;
          this.branchName = res.Name;
        } else if (event.status && event.statusCode === 400) {
          // use this function to trigger back to login page when session expired
          console.log(
            "Found API response as 400, this may cause from login session expired."
          );
          // window.location.href = mainSite + "franchiseportallogin";
        }
        // this.$store.commit("General/setLoading", false);
      });
    },
    changeLang(val) {
      this.$store.commit("General/setLang", val);
      this.$router.go(); // reload
    },
    onLogout() {
      // this.$store.commit('Auth/setAuth')
      this.$store.commit("Auth/clearUserInfo");
      window.location.href = logOutUrl;
    },
    chooseMenu(route) {
      window.location.href = mainSite + route;
      // this.$router.push({ name: route })
    },
    isRouteActive(route) {
      return parentRoute(window.location.pathname) === route;
    },
    getCurrentUser() {
      this.$lc.callApex(`${controllerName}.getCurrentUser`, (res, event) => {
        console.log("event: ", event);
        console.log("current user: ", res);

        if (event.status && event.statusCode === 200 && res) {
          this.$store.commit("Auth/setUserInfo", res);
        }
      });
    },
    getCurrentNotifications() {
      this.$lc.callApex(
        `${controllerName}.getNotificationList`,
        (res, event) => {
          // console.log('event: ', event)

          if (event.status && event.statusCode === 200 && res) {
            // let decoded = document.createElement("textarea");
            // decoded.innerHTML = res;
            // res = JSON.parse(decoded.value);
            console.log("notification decoded res: ", res);
            // modify header string with case
            this.notificationList = res.items ? res.items : [];
          }
        }
      );
    },
    markAllAsRead() {
      if (this.isMarkingAsRead) return;
      this.isMarkingAsRead = true;
      this.$lc.callApex(
        `${controllerName}.markNotification`,
        true,
        (res, event) => {
          // console.log("res: ", res);
          // console.log("event: ", event);

          if (event.status && event.statusCode === 200 && res) {
            this.getCurrentNotifications();
            this.isMarkingAsRead = false;
          }
        }
      );
    },
    onAccept(item) {
      if (item.NeedAcknowledge__c && !item.Acknowledged__c) {
        console.log("skip");
        return;
      }
      console.log("onAccept in Header : ", item);

      // find item in array defaultData and notifications to change read to true
      this.notificationList.find((i) => i.id === item.id).read = true;

      // sort array defaultData and notifications by read = false first
      //   this.defaultData.sort((a, b) => (a.read > b.read ? 1 : -1));
      //   this.notifications.sort((a, b) => (a.read > b.read ? 1 : -1));

      // todo : call api to update read to true

      this.$store.commit("General/setLoading");
      this.$lc.callApex(
        `${controllerName}.readNotification`,
        {
          recordId: item.Id,
        },
        (res, event) => {
          console.log("event: ", event);
          console.log("readNotification: ", res);

          if (event.status && event.statusCode === 200 && res) {
            // this.$swal({
            //   title: "Success",
            //   text: "readNotification Success",
            //   icon: "success",
            //   confirmButtonColor: "#C71010",
            // }).then(() => {
            // this.reload();
            // });
          }
          this.$store.commit("General/setLoading", false);
        }
      );
    },
    onSearch() {
      if (!this.keyword) return;
      window.location.href = mainSite + "SearchNews?keyword=" + this.keyword;
    },
    getUserInfo() {
      console.log("getUserInfo");
      this.$lc.callApex(`${controllerName}.getUserInfo`, (res, event) => {
        console.log("GetUser ", res);
        console.log(event);
        for (const [key, value] of Object.entries(res)) {
          // console.log(`${key}: ${value}`);
          this.form[key] = value;
        }

        // this.form.FirstName = res.data.FirstName;
        // this.form.LastName = res.data.LastName;
        // this.form.CompanyName = res.data.CompanyName;
        // this.form.BranchName = res.data.BranchName;
        // this.form.Email = res.data.Email;
        // this.form.Line_ID__c = res.data.Line_ID__c;
        // this.form.MobilePhone = res.data.MobilePhone;
        // this.form.Phone = res.data.Phone;
        // this.form.Position = res.data.Position;
        if (event.status && event.statusCode === 200 && res) {
          this.$store.commit("Auth/setUserInfo", res);
        }
      });
    },
    seeAll() {
      window.location.href = mainSite + "Notification";
    },
    onChangeBranchAccept() {
      this.branchDialog = false;
      // window.location.reload();
      window.location.href = mainSite + "Dashboard";
    },
  },
};
</script>

<style scoped lang="scss">
.header-app {
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  max-height: var(--header-height);
  min-height: var(--header-height);
  background: #fff;
  box-shadow: 0px -1px 2px rgba(145, 158, 171, 0.24),
    0px 1px 2px rgba(145, 158, 171, 0.24);
  z-index: 90;
}

.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active.custom-menu {
  width: 400px !important;
  right: 20px !important;
  left: auto !important;
}

.profile-icon {
  border-radius: 50%;
  overflow: hidden;
}

.menu-layout {
  display: flex;
  justify-content: space-between;
}

.header-menu {
  padding: 0 16px;
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--theme-color-three);
  font-family: "Prompt", sans-serif;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  &.active {
    font-family: "PromptB", "Prompt", sans-serif;
    color: var(--theme-color-one);
    border-bottom: 2px solid var(--theme-color-one);
  }
}
.header-menu-hover {
  color: var(--theme-color-one);
}

.notification-menu,
.user-menu {
  width: 20px;
  height: 20px;
  // min-width: 28px;
  // min-height: 28px;
  // max-width: 28px;
  // max-height: 28px;
  border-radius: 50%;
  cursor: pointer;
  user-select: none;
  position: relative;
}

.custom-badge {
  font-size: 10px;
  font-weight: bold;
  position: absolute;
  top: -9px;
  right: -9px;
  border-radius: 50%;
  border: 2px solid #dc3545;
  color: #fff;
  background: #dc3545;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
}
.notification-background {
  position: relative;
  .noti-header {
    max-height: 800px;
    overflow: auto;
  }

  // padding: 12px;
  // width: 360px;
  .noti-items-list {
    max-height: 470px;
    .noti-item {
      position: relative;
      cursor: pointer;
      padding: 16px 24px 16px 16px;
      font-size: 14px;
      border-radius: 10px;
      background-color: #fff;
      transition: background-color 200ms;
    }
    .noti-item:hover {
      background-color: #f0f7fa;
    }
  }
  .mark-as-read-btn {
    border-radius: 30px;
    border: solid 1px var(--theme-color-one);
    color: var(--theme-color-one);
    padding: 0 8px;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
  }
  .mark-as-read-btn:hover {
    color: #fff;
    background: var(--theme-color-one);
  }
}

.noti-item .required-dot {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 8px;
  height: 8px;
  background: var(--theme-color-eight);
}

.header-responsive {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-logo {
  margin-right: 8px;
  left: 10px;
}

.mobile-header-menus {
  display: none;
}

.menu-profile {
  box-shadow: 0 -1px 2px rgba(145, 158, 171, 0.24),
    0 1px 2px rgba(145, 158, 171, 0.24);
  border-radius: 10px;
  padding: 16px 12px;
}

@media (max-width: 768px) {
  .header-responsive {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .header-responsive > div {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .header-app {
    padding: 10px 8px;
  }
  .header-logo {
    margin-right: 0;
  }
  .header-logo {
    margin-bottom: 8px;
  }
  // .desktop-header-menus {
  // display: none;
  // }
  .mobile-header-menus {
    display: unset;
  }
  .header-menu.active {
    border-bottom: unset;
  }
}
</style>
